import { Delete, Restore } from '@mui/icons-material';
import { FormControlLabel, Stack, Switch, ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';
import { DemandDocumentFormData } from '~/modules/demand/DemandDocumentWidget/components/DemandDocumentForm/DemandDocumentForm.schema';

export interface DocumentListItemSecondaryActionsProps {
  index: number;
  hasNegotiationCase: boolean;
  isMarkedForDeletion: boolean;
}

export const DocumentListItemSecondaryActions = ({
  index,
  hasNegotiationCase,
  isMarkedForDeletion,
}: DocumentListItemSecondaryActionsProps) => {
  const { t } = useTranslation(I18nNamespace.common, { keyPrefix: 'DocumentListItem' });
  const form = useFormContext<DemandDocumentFormData>();
  const { control, setValue } = form;

  const sharingController = (
    <Controller
      name={`files.${index}.isSharedWithSupplier`}
      control={control}
      render={({ field: { onChange, value } }) => (
        <FormControlLabel
          control={<Switch disabled={hasNegotiationCase} checked={value} onChange={onChange} />}
          label={t('label.visibleToAllSuppliers')}
        />
      )}
    />
  );

  return (
    <Stack direction="row" spacing={3}>
      {hasNegotiationCase ? (
        <Tooltip title={t('tooltip.disabledSharing')}>
          <span>{sharingController}</span>
        </Tooltip>
      ) : (
        sharingController
      )}
      <Controller
        name={`files.${index}.isDeleted`}
        control={control}
        render={({ field }) => {
          return (
            <ToggleButtonGroup
              {...field}
              color="primary"
              exclusive
              onChange={(_, value: boolean) => {
                setValue(field.name, value);
              }}
              aria-label="Platform"
            >
              {
                <ToggleButton value={!isMarkedForDeletion}>
                  {isMarkedForDeletion ? <Restore /> : <Delete />}
                </ToggleButton>
              }
            </ToggleButtonGroup>
          );
        }}
      />
    </Stack>
  );
};
